module.exports = __webpack_public_path__ + "static/media/QuestionMark.3714a361.svg";